import React, { useState } from "react";
import DashboardList from "../components/dashboard/DashboardList";
import { useNavigate } from "react-router-dom";
import OfficerHeader from "../components/header/officerHeader";
import dashboardIcon from "../assets/images/grid_view.png";
import dashboardIcon2 from "../assets/images/grid-view2.png";
import faqIcon from "../assets/images/faq.svg";
import chatIcon from "../assets/images/page.svg";
import logoutIcon from "../assets/images/logout.svg";
import Header from "../components/header";
import { useAuth } from "../utils/AuthContext";
import Feedback from "../components/feedback";
import sidebarImage from "../assets/images/Rectangle 5191.png";
import Footer from "../components/footer";

const Desk = () => {
  const navigate = useNavigate();
  const [activeSection, setActiveSection] = useState("dashboard");
  const { logout } = useAuth();

  const handleSignOut = () => {
    sessionStorage.removeItem("email");
    sessionStorage.removeItem("name");
    sessionStorage.removeItem("userId");
    logout();
    navigate("/");
  };

  return (
    <div className="flex flex-col h-[100dvh] overflow-hidden">
      <Header />
      <div className="flex-1 flex flex-col sm:flex-row overflow-hidden">

        {/* Mobile Top Navigation — visible only on small screens */}
        <div className="flex sm:hidden w-full bg-page-bg border-b border-cream px-4 py-2 gap-3 justify-between overflow-x-auto shrink-0">
          <button
            className={`flex items-center gap-1.5 px-3 py-2 rounded-lg text-xs font-semibold shrink-0 whitespace-nowrap transition-colors ${activeSection === "chatbot" ? "bg-brand-teal text-white" : "bg-white text-black border border-cream"}`}
            onClick={() => { setActiveSection("chatbot"); navigate("/botDesk"); }}
          >
            <img src={chatIcon} alt="" className="w-4 h-4" />
            Lodge Complaints
          </button>
          {/* FAQ button commented out
          <button
            className={`flex items-center gap-1.5 px-3 py-2 rounded-lg text-xs font-semibold shrink-0 whitespace-nowrap transition-colors ${activeSection === "faq" ? "bg-brand-teal text-white" : "bg-white text-black border border-cream"}`}
            onClick={() => { setActiveSection("faq"); navigate("/faq"); }}
          >
            <img src={faqIcon} alt="" className="w-4 h-4" />
            FAQ
          </button>
          */}
          <button
            className={`flex items-center gap-1.5 px-3 py-2 rounded-lg text-xs font-semibold shrink-0 whitespace-nowrap transition-colors ${activeSection === "dashboard" ? "bg-brand-teal text-white" : "bg-white text-black border border-cream"}`}
            onClick={() => setActiveSection("dashboard")}
          >
            <img src={activeSection === "dashboard" ? dashboardIcon2 : dashboardIcon} alt="" className="w-4 h-4" />
            Dashboard
          </button>

        </div>

        {/* Desktop Sidebar */}
        <div className="hidden sm:flex flex-col w-[250px] min-w-[250px] bg-gradient-to-b from-white to-[#fbeef1] border-r-[1.5px] border-[#e8d3d8] shadow-[2px_0_16px_rgba(74,14,30,0.05)] pt-5 px-4 pb-4 shrink-0 justify-between h-full overflow-y-auto relative z-[5]">
          <div className="flex flex-col gap-[10px] w-full">
            <button
              onClick={() => setActiveSection("dashboard")}
              className="w-full flex items-center gap-[10px] py-[13px] px-[16px] rounded-[8px] font-[700] text-[14px] text-white bg-gradient-to-r from-[#4a0e1e] to-[#9c2942] shadow-[0_4px_14px_rgba(156,41,66,0.3)] border-transparent transition-colors duration-150"
            >
              <i className="fa-solid fa-table-columns w-[16px] text-center"></i>
              Dashboard
            </button>

            <button
              className="w-full flex items-center gap-[10px] py-[13px] px-[16px] rounded-[8px] font-[700] text-[14px] text-[#4a0e1e] border-[1.5px] border-[#e8d3d8] transition-colors duration-150 hover:border-[#0e8f6f]"
              onClick={() => {
                setActiveSection("chatbot");
                navigate("/botDesk");
              }}
            >
              <i className="fa-solid fa-comment-medical w-[16px] text-center"></i>
              Lodge Complaint
            </button>
          </div>

          <div className="flex-1"></div>

          <div className="flex flex-col gap-[10px]">
            <Feedback />
            <button onClick={handleSignOut} className="w-full flex items-center justify-center gap-[10px] py-[13px] px-[16px] rounded-[8px] font-[700] text-[14px] text-[#9c2942] bg-[#f7eef0] border-[1.5px] border-[#9c2942] hover:bg-[#9c2942] hover:text-white shadow-sm transition-all duration-200 cursor-pointer">
              <i className="fa-solid fa-arrow-right-from-bracket w-[16px] text-center"></i>
              Logout
            </button>
          </div>
        </div>

        {/* Main Content */}
        <main className="flex-1 overflow-y-auto">
          {activeSection === "dashboard" && <DashboardList />}
        </main>
      </div>
      <Footer />
    </div>
  );
};

export default Desk;
